export function getReceiptStatus(status) {
  if (status === "full") return "已交付";
  if (status === "partial") return "部分交付";
  return "未交付";
}

export function getOrderStatus(status) {
  if (status === "draft") return "草稿";
  if (status === "sent") return "已发送";
  if (status === "purchase") return "已确认";
  if (status === "done") return "已完成";
  if (status === "cancel") return "已取消";
  return status;
}
